import React, { useState } from "react";
import { CiFilter } from "react-icons/ci";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import APopover from "views/pages/manage/common/pop-hover/APophover";
import  FilterForm  from "./FilterForm";
import { useWizard } from "../../../../../components/wizard/WizardContext";
import { useSearchStudentsHandler } from "../../../customHooks";
import { getBulkOnlyFilters } from "../../utils";

const normalStyle = {
  // border: "1px solid #CCCCCC",
  border: "1px solid #E9ECEF",
  color: "#0F0F0F",
};
const FilterButton = ({FilterForm, searchHandler}) => {
  const [anchorFilterEl, setAnchorFilterEl] = useState(null);
  const { values, dropdowns, updateValues } = useWizard();
  // const { searchHandler } = useSearchStudentsHandler();


  const inputHandler = (filters) => {
    searchHandler(filters, 0, false, 50);
    setAnchorFilterEl(null)
  };

  return (
    <>
      <AButton
        updatedStyle={normalStyle}
        onClick={(event) => {
          setAnchorFilterEl(event.currentTarget);
        }}
      >
        <CiFilter />
        Filter
      </AButton>

      <APopover
        handleClose={() => setAnchorFilterEl(null)}
        id="transfer-filter"
        anchorEl={anchorFilterEl}
      >
        <FilterForm
          inputHandler={inputHandler}
          formModal={getBulkOnlyFilters(values["searchStudentsFilters"])}
          dropdowns={dropdowns?.data}
        />
      </APopover>
    </>
  );
};

export default FilterButton;
